import React from 'react';
import styled from 'styled-components';

const Header = () => {
  return (
    <StyledHeader>
      <div style={styles.logoContainer}>
        <img
          src="/logo.jpg"
          alt="CASPH ROYAL Logo"
          style={styles.logo}
        />
        <h1 style={styles.title}>CASPH ROYAL</h1>
      </div>
      <p style={styles.subtitle}>Coopérative Agro-Sylvo-Pastorale et Halieutique</p>
    </StyledHeader>
  );
};

const StyledHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #2E8B57; 
  color: #fff;
  text-align: center;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

const styles = {
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexDirection: 'row',
  },
  logo: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
  },
  title: {
    margin: 0,
    fontSize: '2rem',
    fontWeight: 'bold',
  },
  subtitle: {
    marginTop: '10px',
    fontSize: '1.2rem',
  },
};

export default Header;
